import { fetch } from '@utils/utils';

import * as T from '@modules/operationalWarehouse/_operationalWarehouseTypes';
import { operationalWarehouseUrl } from './operationalWarehouseGrid';

const getOperationalWarehouse =
  ({ addError }) =>
  async (id: string): Promise<T.OperationalWarehouse> => {
    try {
      const response: any = await fetch(`${operationalWarehouseUrl}/${id}`, {
        method: 'GET',
        headers: new Headers({ 'Content-Type': 'application/json' })
      });

      const json: T.OperationalWarehouse = await response.json();

      return json;
    } catch (err) {
      addError(err.message);
      return {};
    }
  };

const prepareFieldOrSort = fieldOrSort => (fieldOrSort === 'state' ? 'state.id' : fieldOrSort);

const getParams = ({ sort, order, pageSize, page, filters, universalFilter, query, allowDeleted, doPost }) => {
  const filterClean = filters
    .filter(({ field }) => field !== null)
    .filter(({ operation }) => operation !== null)
    .filter(({ value }) => value !== null)
    .filter(({ value }) => value !== '')
    .filter(({ value }) => value !== undefined);
  let filter = null;
  filter = filterClean.reduce((acc, { field, operation, value, aggregation }) => {
    const realField = prepareFieldOrSort(field);
    const agg = acc.find(a => prepareFieldOrSort(a.field) === realField && a.operation === aggregation);
    return !aggregation
      ? [
          ...acc,
          {
            field: realField,
            operation: operation,
            value: value
          }
        ]
      : agg
      ? [
          ...acc.filter(a => !(prepareFieldOrSort(a.field) === realField && a.operation === aggregation)),
          {
            ...agg,
            filter: [
              ...agg.filter,
              {
                field: realField,
                operation: operation,
                value: value
              }
            ]
          }
        ]
      : [
          ...acc,
          {
            field: realField,
            operation: aggregation,
            filter: [
              {
                field: realField,
                operation: operation,
                value: value
              }
            ]
          }
        ];
  }, []);

  let constructedUniversalFilter = {};
  if (universalFilter) {
    constructedUniversalFilter = doPost
      ? { universalFilter: { value: universalFilter } }
      : { 'universalFilter.value': universalFilter };
  }

  const constructedSort = sort ? { sort: prepareFieldOrSort(sort), order } : undefined;

  return {
    pageSize,
    page,
    ...constructedSort,
    ...query,
    ...(doPost ? { filter } : filter),
    ...constructedUniversalFilter,
    allowDeleted: !!allowDeleted
  };
};

const getOperationalWarehouses = async (url, props) => {
  const params = getParams(props);
  const response = await fetch(`${url}/parametrized`, {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(params)
  });
  return await response.json();
};

type OperationalWarehouseActionBody =
  | { categoryId: string; warehouseId: string; amount: number; firstNumber: number }
  | { fromWarehouseId: string; toEmployeeId: string; itemIds: string[] }
  | { fromEmployeeId: string; toEmployeeId: string; itemIds: string[] }
  | { returnFromEmployeeId: string; returnToWarehouseId: string; itemIds: string[] }
  | { fileId: string; finalState: string; items: string[] }
  | { itemIds: string[] };

const operationalWarehouseAction =
  ({ addSuccess, addError }) =>
  async (
    url: string,
    successMessage: string,
    errorMessage: string,
    body: OperationalWarehouseActionBody
  ): Promise<boolean> => {
    try {
      const response: any = await fetch(`${operationalWarehouseUrl}/${url}`, {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(body)
      });

      if (response.ok) {
        addSuccess(successMessage);
        return true;
      } else {
        addError(errorMessage);
        return false;
      }
    } catch (err) {
      addError(err.message);
      return false;
    }
  };

const putItem =
  ({ addError, addSuccess }) =>
  async (id: string, note: string): Promise<boolean> => {
    try {
      const response: any = await fetch(`${operationalWarehouseUrl}/${id}`, {
        method: 'PUT',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ note })
      });

      if (response.ok) {
        addSuccess('Předmět byl úspěšně uložen');
        return true;
      } else {
        addError('Předmět nebyl uložen');
        return false;
      }
    } catch (err) {
      addError(err.message);
      return false;
    }
  };

const deleteItems =
  ({ addError, addSuccess }) =>
  async (itemIds: string[]): Promise<boolean> => {
    try {
      const response: any = await fetch(`${operationalWarehouseUrl}/delete`, {
        method: 'DELETE',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ itemIds })
      });

      if (response.ok) {
        addSuccess('Předmět byl úspěšně zlikvidován');
        return true;
      } else {
        addError('Předmět se nepodařilo zlikvidovat');
        return false;
      }
    } catch (err) {
      addError(err.message);
      return false;
    }
  };

export { getOperationalWarehouse, getOperationalWarehouses, operationalWarehouseAction, putItem, deleteItems };



// WEBPACK FOOTER //
// ./src/modules/operationalWarehouse/_operationalWarehouseActions.ts